import * as zod from 'zod'

const rate = zod
  .number({ invalid_type_error: 'Must be a valid number' })
  .positive({ message: 'Must be greater than 0' })
  .max(10000, { message: 'Must be less than 10,000' })

export const editBillRateFlowSchema = zod.object({
  payRate: rate,
  billRate: rate,
})

export type EditBillRateFlowSchema = zod.infer<typeof editBillRateFlowSchema>
